import clsx from "clsx";
import { formatCount } from "../utils";
import s from "./CountBadge.module.css";

export function CountBadge({ count, emphasis = false, className }: { count: number; emphasis?: boolean; className?: string }) {
  if (count <= 0) return null;
  return <span className={clsx(s.badge, emphasis && s.emphasis, "df-tabular", className)}>{formatCount(count)}</span>;
}
